import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a326f24"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "spacer" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "11" })
], -1))
const _hoisted_2 = { class: "customer-list__content__table__item" }
const _hoisted_3 = { class: "customer-list__content__table__item__details__cell customer-list__content__table__item__details__cell--client" }
const _hoisted_4 = { class: "customer-list__content__table__item__details__cell customer-list__content__table__item__details__cell--number" }
const _hoisted_5 = { class: "customer-list__content__table__item__details__cell customer-list__content__table__item__details__cell--created" }
const _hoisted_6 = { class: "customer-list__content__table__item__details__cell customer-list__content__table__item__details__cell__actions" }
const _hoisted_7 = { class: "customer-list__content__table__item__details__cell__actions__action" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-show" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "text-big font-medium" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, " / ", -1))
const _hoisted_13 = { class: "font-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_row_actions = _resolveComponent("customer-row-actions")!
  const _component_customer_details_modal = _resolveComponent("customer-details-modal")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("tr", _hoisted_2, [
      _createElementVNode("td", _hoisted_3, " # " + _toDisplayString(_ctx.customer.id), 1),
      _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.customer.companyName), 1),
      _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.customer.country?.name), 1),
      _createElementVNode("td", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showClientModal = true))
          }, _hoisted_9)
        ])
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_customer_row_actions, { customer: _ctx.customer }, null, 8, ["customer"])
        ])
      ])
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showClientModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showClientModal) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.customer.companyName), 1),
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.customer.id), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_customer_details_modal, { customer: _ctx.customer }, null, 8, ["customer"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}